import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { ProfileService } from 'src/app/services/profile/profile.service';
import {FormServiceService} from "../../services/publications/form-service.service";
import Swal2 from "sweetalert2";
import { RequestService } from 'src/app/services/request/request.service';
import { ModalController } from '@ionic/angular';
import { PagoVerificacionComponent } from 'src/app/components/pago-verificacion/pago-verificacion.component';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.page.html',
	styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
	stories=[];
	public available_sections: Array<string> = ["Fachada", "Posts", "Relaciones"]; //, "Estados"
	public icons_for_sections: Array<string> = ["person-outline", "tv", "people-outline"]; //, "hourglass-outline"
	public actual_section:string = "Fachada";

	public profile: any = null;
	public profile_id: number;
	public focusPublicationId: number | null = null;
  public mostrar = true;
  public showLoginInvitation = false;
  public profileControlsFaded = false;
  public profileLoading = true;
  private profileLoadToken = 0;

	constructor(
		public changeDetector: ChangeDetectorRef,
		private profile_service: ProfileService,
		public route: ActivatedRoute,
		private router: Router,
		public formService: FormServiceService,
		private request: RequestService,
		private modalController: ModalController,


	) {
		this.profile_id = this.resolveProfileId();
	}

	async openPremiumVerification(): Promise<void> {
		const profile = this.formService?.profile || this.profile;

		if (!profile) {
			this.openLogin();
			return;
		}

		if (profile?.kyc === 'Validado') {
			Swal2.fire({
				title: 'Premium activo',
				text: 'Tu perfil ya está verificado.',
				icon: 'success',
				timer: 3600,
				timerProgressBar: true,
				toast: true,
				position: 'top-start',
				showConfirmButton: false,
				background: '#010f4e',
				color: '#ffffff',
			});
			return;
		}

		const modal = await this.modalController.create({
			component: PagoVerificacionComponent,
			cssClass: 'detailsInModal',
			canDismiss: true,
			componentProps: {
				pr: profile,
			},
		});
		await modal.present();
	}

	ngOnInit(){
		this.route.queryParams.subscribe((params) => {
			if (params['section'] === 'Posts') {
				this.actual_section = 'Posts';
			}
			const publicationId = Number(params['focusPublicationId']);
			this.focusPublicationId = Number.isSafeInteger(publicationId) && publicationId > 0
				? publicationId
				: null;
		});

		// Alien animation replaced by the beautiful qubit/atom loader in SectionsProfileComponent on init
		// this.showAlienIntelligenceAnimation();
		this.route.params.subscribe(() => {
			this.profile_id = this.resolveProfileId();
			this.loadProfile();
		});

		if (this.route.parent) {
			this.route.parent.params.subscribe(() => {
				this.profile_id = this.resolveProfileId();
				this.loadProfile();
			});
		}

		this.loadProfile();

		console.log("hola estas en el ngoninit")

	}

	private resolveProfileId(): number {
		const currentProfileId = this.route.snapshot.paramMap.get('profile_id');
		const parentProfileId = this.route.parent?.snapshot.paramMap.get('profile_id');
		const routeValue = currentProfileId || parentProfileId;
		return routeValue ? Number(routeValue) : null;
	}

	get showPublicDiscoveryCta(): boolean {
		return !!this.profile && !this.profile.owner && !this.formService?.profile;
	}

	joinLaniakeaFromProfile(): void {
		void this.router.navigate(['/login'], {
			queryParams: { returnUrl: this.router.url },
		});
	}

	openInMycelium(): void {
		if (!this.profile_id) return;
		void this.router.navigate(['/mycelium'], { queryParams: { profileId: this.profile_id } });
	}

	private showAlienIntelligenceAnimation() {
		if (!document.getElementById('lia-alien-intelligence-style')) {
			const style = document.createElement('style');
			style.id = 'lia-alien-intelligence-style';
			style.innerHTML = `
				.alien-intelligence-popup {
					border: 1px solid rgba(87, 255, 224, 0.35);
					box-shadow: 0 0 26px rgba(87, 255, 224, 0.2), inset 0 0 18px rgba(120, 79, 255, 0.18);
					border-radius: 16px;
				}
				.lia-loader { display: grid; place-items: center; gap: 10px; }
				.lia-orb {
					position: relative;
					width: 76px;
					height: 76px;
					border-radius: 50%;
					background: radial-gradient(circle at 35% 35%, #b9fff3 0%, #65ffe7 28%, #4f2cd8 70%, #0f0538 100%);
					box-shadow: 0 0 22px rgba(101, 255, 231, 0.55), 0 0 48px rgba(115, 61, 255, 0.35);
					overflow: hidden;
				}
				.lia-orb::before, .lia-orb::after {
					content: '';
					position: absolute;
					inset: -8px;
					border: 2px solid rgba(122, 255, 226, 0.45);
					border-radius: 50%;
					animation: liaPulse 1.8s ease-out infinite;
				}
				.lia-orb::after { animation-delay: .6s; }
				.lia-copy { font-size: 12px; letter-spacing: .8px; color: #d8fff9; text-transform: uppercase; }
				.lia-dots::after { content: '...'; animation: liaDots 1.2s steps(4, end) infinite; }
				@keyframes liaPulse { from { transform: scale(.72); opacity: .9; } to { transform: scale(1.28); opacity: 0; } }
				@keyframes liaDots { 0% { content: ''; } 33% { content: '.'; } 66% { content: '..'; } 100% { content: '...'; } }
			`;
			document.head.appendChild(style);
		}

		Swal2.fire({
			title: '👽 Alien Intelligence',
			html: `
				<div class="lia-loader">
					<div class="lia-orb"></div>
					<div class="lia-copy">Neural link calibrating<span class="lia-dots"></span></div>
				</div>
			`,
			showConfirmButton: false,
			timer: 2400,
			timerProgressBar: true,
			backdrop: 'rgba(2, 7, 31, 0.88)',
			background: 'linear-gradient(155deg, #050a2c 0%, #170b3f 50%, #04122b 100%)',
			color: '#e8fffd',
			customClass: {
				popup: 'alien-intelligence-popup'
			}
		});
	}

	ionViewWillEnter() {
		this.loadProfile();
		/*
			setTimeout(() => {
		 if(this.formService.titleHeader==='🔑PERFIL'){
			Swal2.fire({
			  title: '🔑',
			  text: 'You must sign in. Da click en "🔑PERFIL", para ver tu perfil.',
			  icon: 'info',
			  confirmButtonText: 'Understood',
			  background: '#010f4e',
			  });
		  }
		}, 999);*/
	}

	private loadProfile() {
		const loadToken = ++this.profileLoadToken;
		this.profileLoading = true;
		const cachedProfile = this.formService.profile;

		if (this.profile_id) {
			this.showLoginInvitation = false;
			this.profile_service.getProfileInfo(this.profile_id).then((profileInfo) => {
				if (loadToken !== this.profileLoadToken) return;
				profileInfo = typeof profileInfo === 'string' ? JSON.parse(profileInfo) : profileInfo;
				this.profile = profileInfo;
				this.profile_id = profileInfo.id;
			}).catch((error) => {
				if (loadToken !== this.profileLoadToken) return;
				console.error(error);
				this.profile = null;
				this.showLoginInvitation = true;
			}).finally(() => {
				if (loadToken === this.profileLoadToken) this.profileLoading = false;
			});
			return;
		}

		if (cachedProfile?.id) {
			this.profile = cachedProfile;
			this.profile_id = cachedProfile.id;
			this.showLoginInvitation = false;
			this.profileLoading = false;
			return;
		}

		this.profile_service.getProfileInfo().then((profileInfo) => {
			if (loadToken !== this.profileLoadToken) return;
			profileInfo = typeof profileInfo === 'string' ? JSON.parse(profileInfo) : profileInfo;
			if (profileInfo?.id) {
				this.profile = profileInfo;
				this.profile_id = profileInfo.id;
				this.showLoginInvitation = false;
				return;
			}

			this.profile = null;
			this.showLoginInvitation = true;
		}).catch((error) => {
			if (loadToken !== this.profileLoadToken) return;
			console.error(error);
			this.profile = null;
			this.showLoginInvitation = true;
		}).finally(() => {
			if (loadToken === this.profileLoadToken) this.profileLoading = false;
		});
	}

	openLogin() {
		this.router.navigate(['/login']);
	}

	section_change(filtro){
		this.profileControlsFaded = false;
		this.actual_section = filtro;
		if(this.actual_section == 'Historias'){
			this.getStories();
			this.mostrar=false;
		}
	}

	setProfileControlsFaded(faded: boolean): void {
		this.profileControlsFaded = faded;
	}

	reloadProfile(){
		this.profile_service.getProfileInfo(this.profile_id).then((data)=>{
			data = JSON.parse(data);

			this.profile = data;
			this.profile_id = data.id;
		}).catch((error)=>{
			console.error(error);
		}).finally(()=>{

		});
	}
	public getStories() {
		this.request.createRequestPost('get_stories_by_user', { profile_id: this.profile_id })
			.then((final_data) => {
				if (final_data && typeof final_data === 'string') {
					try {
						final_data = JSON.parse(final_data);
					  console.log('getRecordByToken ios:',final_data);
					} catch (error) {
					  console.error("Error parsing data:", error);
					}
					}
				console.log('stories1', final_data);
	
				final_data.forEach((publication, index) => {
					console.log(`Processing publication ${index + 1} with id ${publication.id}`);
					if (publication.container && Array.isArray(publication.container.states)) {
						publication.container.states.forEach((state, stateIndex) => {
							console.log(`Pushing state ${stateIndex + 1} of publication ${publication.id}`);
							console.log(state);
							if(state.multimediaCounter !== 0){
								this.stories.push(state);
							}
						
						});
					}
					console.log('Current length of stories:', this.stories.length);
				});
	
				console.log('Final stories array:', this.stories);

			})
			.catch((error) => {
				console.error('Error fetching stories:', error);
			});
	}
	
}
